export default "__VITE_ASSET__QhsxmXan__"